import React from 'react'
import { FaRobot } from 'react-icons/fa'
import { Stack, Box, Avatar, Text, Tooltip, Icon } from '@/components/lib'

export default function UserChip ({ vertical, user, onlyAvatar, compact, meta, avatarColorPalette }) {
  if (!user) return null

  // If a system user
  if (user._id === '000000000000000000000000') {
    if (onlyAvatar) {
      return (
        <Tooltip content='System'>
          <Box h='25px' w='25px' rounded='md' bg='primary.subtle' p={0.5} textAlign='center' display='inline-block'>
            <Icon as={FaRobot} color='fg.default' />
          </Box>
        </Tooltip>
      )
    }
    return (
      <Stack direction='row' alignItems='center'>
        <Box h='30px' w='30px' rounded='md' bg='primary.subtle' p={0.5} textAlign='center'>
          <Icon as={FaRobot} color='fg.default' />
        </Box>
        <Box>
          <Text fontWeight='semibold' fontSize={compact ? 'sm' : 'md'}>System</Text>
          <Text color='fg.muted' fontSize='xs'>Trialflare system</Text>
        </Box>
      </Stack>
    )
  }

  if (onlyAvatar) {
    return (
      <Tooltip content={`${user.firstName || ''} ${user.lastName || ''}` + (user.email ? ` (${user.email})` : '')}>
        <Box display='inline-block'>
          <Avatar size={compact ? 'xs' : 'sm'} name={user.firstName || user.email} colorPalette={avatarColorPalette} />
        </Box>
      </Tooltip>
    )
  }
  return (
    <Stack alignItems='center' direction={vertical ? 'column' : 'row'}>
      <Avatar size={compact ? 'xs' : 'sm'} name={user.firstName || user.email} colorPalette={avatarColorPalette} />
      <Box textAlign={vertical ? 'center' : 'left'}>
        {(user.firstName || user.lastName)
          ? (
            <Text fontWeight='semibold' fontSize={compact ? 'sm' : 'md'}>{user.firstName} {user.lastName}</Text>)
          : (
            <Text fontWeight='semibold' fontSize={compact ? 'sm' : 'md'}>Unknown user</Text>
            )}
        {user.email && <Text color='fg.muted' fontSize='xs'>{user.email}</Text>}
      </Box>
      {meta && <span style={{ color: 'rgb(180,180,180)', fontSize: 10 }}>{meta}</span>}
    </Stack>
  )
}
